// extracted by mini-css-extract-plugin
module.exports = {"main-content":"style_main-content__1UuSr"};